// extracted by mini-css-extract-plugin
export default {"ctr":"ELNObjectEditor_ctr__JSfz1","buttonsCtr":"ELNObjectEditor_buttonsCtr__9hA4D"};